import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const loginUser = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response.data;
};

export const registerUser = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await api.post('/auth/reset-password', { email });
  return response.data;
};